// This function is used to bypass the error thrown by the mock server when the response is not a valid JSON. USED for STORYBOOK MOCK SERVER

const bypassMockError = (error: any, callback?: any) => {
   const isMockError =
      error.message === "Invalid character: the string to be decoded is not correctly encoded."
   if (!isMockError) return callback && callback(error)
}

export default bypassMockError
